
































import { computed, defineComponent, PropType, ref, toRef, watch } from "@vue/composition-api";
import { TagInfo, TagInfoType } from "@scrile/api-provider/dist/api/TagsProvider";
import { UserLocation } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import config from "@/config";
import BaseButton from "@/components/BaseButton";
import FilterLanguage from "@/components/FilterLanguage";
import FilterLocation from "@/components/FilterLocation";
import FilterTags from "@/components/FilterTags";
import ModalView from "@/components/ModalView";

export default defineComponent({
  name: "DiscoverFiltersModal",
  components: {
    FilterTags,
    BaseButton,
    ModalView,
    FilterLocation,
    FilterLanguage,
  },
  props: {
    value: { type: Boolean, required: true },
    tagIds: { type: Array as PropType<string[]>, default: () => [] },
    hashtagIds: { type: Array as PropType<string[]>, default: () => [] },
    languages: { type: Array as PropType<string[]>, default: () => [] },
    locations: { type: Array as PropType<UserLocation[]>, default: () => [] },
  },
  setup(props, { emit }) {
    const selectedTags = ref<TagInfo[]>();
    const selectedTagIds = ref<string[]>(props.tagIds);
    const selectedHashtags = ref<TagInfo[]>();
    const selectedHashtagIds = ref<string[]>(props.hashtagIds);
    const selectedLocations = ref<UserLocation[]>();
    const selectedLanguages = ref<string[]>();
    const showLocalization = computed(() => !config.featureHideLocalization);
    const showTags = computed(() => config.featureTags);
    const showHashtags = computed(() => config.featureHashtags);

    const onSelectTags = (tags: TagInfo[], type: TagInfoType) => {
      if (type === TagInfoType.USERS) {
        selectedTags.value = tags;
        selectedTagIds.value = tags.map(i => i.id);
      }
      if (type === TagInfoType.POSTS) {
        selectedHashtags.value = tags;
        selectedHashtagIds.value = tags.map(i => i.id);
      }
    };

    const save = () => {
      emit("update", {
        tags: selectedTags.value,
        hashtags: selectedHashtags.value,
        locations: selectedLocations.value,
        languages: selectedLanguages.value,
      });
    };

    watch(toRef(props, "value"), () => {
      selectedTagIds.value = props.tagIds;
      selectedHashtagIds.value = props.hashtagIds;
      selectedLocations.value = props.locations;
      selectedLanguages.value = props.languages;
    });

    return {
      showLocalization,
      showTags,
      showHashtags,
      selectedTags,
      selectedHashtags,
      TagInfoType,
      selectedLocations,
      selectedLanguages,
      selectedTagIds,
      selectedHashtagIds,
      save,
      onSelectTags,
    };
  },
});
